var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPromiseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.06181C1 3.26608 3.131 1 5.76007 1C7.61051 1 9.21349 2.12298 10 3.76388C10.7865 2.12298 12.3895 1 14.2399 1C16.869 1 19 3.12529 19 6.06181C19 11.2962 10 17 10 17C10 17 1 11.2962 1 6.06181Z",
    stroke: "#6856DB",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromiseIcon);
export default __webpack_public_path__ + "static/media/PromiseIcon.a887d17d2f97b9e07bf5dc678bd14900.svg";
export { ForwardRef as ReactComponent };